<template>
  <div>
    <SleepWorkshopComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import SleepWorkshopComp from "@/components/desktop/Activities/SleepWorkshopComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'SleepWorkshop',
    props: ['mobile'],
    components: {
      SleepWorkshopComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
